import { createFragmentContainer, graphql } from 'react-relay/legacy';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'dibs-react-intl';
import classNames from 'classnames';

import { Link } from 'dibs-elements/exports/Link';
import { CreatorsVerticalName } from './CreatorsVerticalName';
import { CreatorsTitle } from './CreatorsTitle';

import styles from './styles/CreatorsSidebar.scss';
import { formatCreatorsAttribute } from './helpers/formatCreatorsAttribute';

const verticals = ['furniture', 'art', 'jewelry', 'fashion'];

function CreatorsSidebarComponent(props) {
    const { nationality, style, viewer } = props;

    let title = <FormattedMessage id="CreatorsSidebar.title" defaultMessage="Creators" />;

    if (nationality || style) {
        title = (
            <FormattedMessage
                id="CreatorsSidebar.attributeTitle"
                defaultMessage="{style} Creators"
                values={{
                    style: formatCreatorsAttribute(
                        nationality ? 'nationality' : 'style',
                        nationality ? nationality : style,
                        viewer
                    ),
                }}
            />
        );
    }

    return (
        <div className={styles.wrapper}>
            <CreatorsTitle tagName="header" dataTn="sidebar">
                {title}
            </CreatorsTitle>
            <ul className={styles.navList}>
                {verticals.map(vertical => {
                    const isSelected = vertical === props.vertical;
                    const dataTn = `creator-${vertical}`;
                    return (
                        <li key={vertical} className={styles.listItem} data-tn={dataTn}>
                            <Link
                                className={classNames(styles.link, {
                                    [styles.isSelected]: isSelected,
                                })}
                                href={`/creators/${vertical}/`}
                            >
                                <CreatorsVerticalName vertical={vertical} />
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
}

CreatorsSidebarComponent.propTypes = {
    nationality: PropTypes.string,
    style: PropTypes.string,
    vertical: PropTypes.string.isRequired,
    viewer: PropTypes.object.isRequired,
};

export const CreatorsSidebar = createFragmentContainer(CreatorsSidebarComponent, {
    viewer: graphql`
        fragment CreatorsSidebar_viewer on Viewer {
            ...formatCreatorsAttribute_viewer
        }
    `,
});
